import React, { useEffect } from "react";
import { Text } from "../../text";
import { defaultStyles } from "../../../../constants/style-constants/utils";
import Modal from "../modal";
import fileUploadIcon from "../../../../assets/SVGs/Vector.svg";
import downloadIcon from "../../../../assets/images/budget/download.png";
import { Button } from "../../button";
import * as Style from "./styles/add-simple-modal";
import { Icon, Button as AntButton } from "antd";
import { Input } from "../../../input/Input";
import { InputGroup1 } from "../../input/styles/input";
import DropDown from "../../dropdown/dropdown";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { Select } from "antd";
import NewLoader from "../../loader/NewLoader";
const { Option } = Select;

function AddSimpleModal({
  show,
  close,
  fields,
  submitData,
  modalTitle,
  obj,
  onChange,
  selectedRowData,
  onSelectChange,
  handleItemsInfoImageChange,
  handleImageDelete,
  loading,
  activeTab,
  setActiveTab,
  downloadSampleFile,
  uploadCollection,
}) {
  const { styles } = defaultStyles;

  const handleSubmit = () => {
    submitData();
    // close();
  };
  const history = useHistory();
  let DropDownValues = [
    { id: 1, value: "Bookkeeper" },
    { id: 2, value: "CPA" },
    { id: 3, value: "Financial Advisor" },
  ];
  useEffect(() => {
    if (fields) {
      !fields.attributes &&
        history.push({
          pathname: "/collectibles_new",
        });
    }
  }, [fields]);

  return (
    <Modal show={show}>
      <Style.HeaderConatiner>
        <Text style={styles.text.formHeaderText}>{modalTitle}</Text>
        <Icon type="close" onClick={close}></Icon>
      </Style.HeaderConatiner>
      {modalTitle === "Add Item" && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="social-security-toggle-container">
            <div
              className={`social-security-toggle-button-container ${
                activeTab === "addSingleItem" ? "active" : ""
              }`}
            >
              <button
                className={`social-security-toggle-button ${
                  activeTab === "addSingleItem" ? "active" : ""
                }`}
                onClick={() => setActiveTab("addSingleItem")}
              >
                Add Item
              </button>
            </div>
            <div
              className={`social-security-toggle-button-container ${
                activeTab === "addMultipleitem" ? "active" : ""
              }`}
            >
              <button
                className={`social-security-toggle-button ${
                  activeTab === "addMultipleitem" ? "active" : ""
                }`}
                onClick={() => setActiveTab("addMultipleitem")}
              >
                Add Entire Collection
              </button>
            </div>
          </div>
        </div>
      )}
      {activeTab === "addSingleItem" ? (
        <Style.FieldsContainer>
          {fields &&
            fields.attributes &&
            fields.attributes.map((input, index) => {
              if (
                input.dataType.toLowerCase() === "string" ||
                input.dataType.toLowerCase() === "int" ||
                input.dataType.toLowerCase() === "float" ||
                input.dataType.toLowerCase() === "formula"
              ) {
                return (
                  <InputGroup1 key={index}>
                    <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                      {input.name}
                    </div>
                    <Input
                      placeholder={input.name}
                      name={input.name}
                      type="text"
                      disabled={
                        input.dataType.toLowerCase() === "formula" ||
                        modalTitle === "View Item"
                          ? true
                          : false
                      }
                      style={{
                        opacity:
                          input.dataType.toLowerCase() === "formula"
                            ? "0.6"
                            : "1",
                        cursor:
                          input.dataType.toLowerCase() === "formula"
                            ? "not-allowed"
                            : "",
                      }}
                      value={selectedRowData && selectedRowData[input.name]}
                      // onChange={(event) => handleContactInfo(event)}
                      onChange={(event) => onChange(event.target)}
                    />
                  </InputGroup1>
                );
              } else if (
                input.dataType.toLowerCase() == "calender" ||
                input.dataType.toLowerCase() == "date"
              ) {
                return (
                  <InputGroup1 key={index}>
                    <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                      {input.name}
                    </div>
                    <Input
                      placeholder={input.name}
                      name={input.name}
                      type="date"
                      disabled={modalTitle === "View Item" ? true : false}
                      value={
                        selectedRowData &&
                        moment(selectedRowData[input.name]).format("YYYY-MM-DD")
                      }
                      // onChange={(event) => handleContactInfo(event)}
                      onChange={(event) => {
                        onChange(event.target);
                      }}
                    />
                  </InputGroup1>
                );
              } else if (
                input.dataType.toLowerCase() === "image" &&
                !input.button
              ) {
                return (
                  <InputGroup1 key={index}>
                    <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                      {input.name}
                    </div>
                    <Input
                      placeholder={input.name}
                      name={input.name}
                      type="file"
                      disabled={modalTitle === "View Item" ? true : false}
                      // onChange={(event) => handleContactInfo(event)}
                      onChange={(event) =>
                        handleItemsInfoImageChange(event.target)
                      }
                    />
                    {input.name === "Image" &&
                      selectedRowData &&
                      Array.isArray(selectedRowData[input.name]) &&
                      selectedRowData[input.name].map((item, index) => (
                        <div
                          key={index}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <img
                            style={{
                              height: "40px",
                              width: "40px",
                              margin: "5px",
                            }}
                            src={item}
                            alt={`image-${index}`}
                          />
                          <AntButton
                            onClick={(e) =>
                              handleImageDelete(e, item, input.name)
                            }
                            icon="delete"
                            style={{
                              margin: "3px",
                            }}
                          />
                        </div>
                      ))}
                    {input.name === "Upload Document" &&
                      selectedRowData &&
                      selectedRowData[input.name] &&
                      Array.isArray(selectedRowData[input.name]) &&
                      selectedRowData[input.name][0] && (
                        <div>
                          <a
                            href={selectedRowData[input.name][0]}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Uploaded Document
                          </a>
                        </div>
                      )}
                  </InputGroup1>
                );
              } else if (input.dataType.toLowerCase() === "dropdown") {
                {
                  console.log("input in dropdown", selectedRowData[input.name]);
                }
                return (
                  <InputGroup1>
                    <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                      {input.name}
                    </div>
                    <Select
                      showSearch
                      name={input.name}
                      title={input.name}
                      disabled={modalTitle === "View Item" ? true : false}
                      id={input.name}
                      placeholder="-Select-"
                      // defaultValue={
                      //   payload && payload[item.name] ? payload[item.name] : ""
                      // }
                      defaultValue={
                        selectedRowData && selectedRowData[input.name]
                      }
                      onChange={(value) => {
                        onSelectChange(input.name, value);
                      }}
                      // size={size}
                    >
                      {input.attribute_default_values.map((states, index) => (
                        <Option key={index} value={states.value}>
                          {states.value}
                        </Option>
                      ))}
                    </Select>
                    {/*  <DropDown
                    style={defaultStyles.styles.dropDown.m_smallDropdown}
                    listingStyle={{
                      ...defaultStyles.styles.dropDown.m_smallDropdown,
                      height: "auto",
                    }}
                    name={input.name}
                    title={input.name}
                    list={[
                      { id: 1, value: "Bookkeeper" },
                      { id: 2, value: "CPA" },
                      { id: 3, value: "Financial Advisor" },
                    ]}
                    displayKey="value"
                    disableSearch={false}
                    setSelectedItem={(event) => onChange(event.target)}

                  // setSelectedItem={({ name, value }) => {
                  //   handleInputFields(name, value);
                  // }}
                  // defaultValue={
                  //   payload && payload[item.name] ? payload[item.name] : ""
                  // }
                  />
                  <DropDown
                    style={defaultStyles.styles.dropDown.largeDropDown}
                    name={input.name}
                    title={input.name}
                    // setSelectedItem={onChange}
                    // list={states}
                    list={[
                      { id: 1, value: "Bookkeeper" },
                      { id: 2, value: "CPA" },
                      { id: 3, value: "Financial Advisor" },
                    ]}
                    displayKey="name"
                  />
                  */}
                  </InputGroup1>
                );
              }
            })}
          {/* <InputGroup>
          <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
            First Name
          </Text>
          <Input
            placeholder="First Name"
            name="fistName"
            type="text"
            // onChange={(event) => handleContactInfo(event)}
          />
        </InputGroup>
        <InputGroup>
          <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
            First Name
          </Text>
          <Input
            placeholder="First Name"
            name="fistName"
            type="date"
            // onChange={(event) => handleContactInfo(event)}
          />
        </InputGroup>
        <InputGroup>
          <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
            First Name
          </Text>
          <Input
            placeholder="First Name"
            name="fistName"
            type="file"
            // onChange={(event) => handleContactInfo(event)}
          />
        </InputGroup>

        <InputGroup>
          <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
            First Name
          </Text>
          <DropDown
            style={defaultStyles.styles.dropDown.largeDropDown}
            name="test"
            title="test"
            // setSelectedItem= handleTaxCreditInfo,

            list={[
              { id: 1, name: "Bookkeeper" },
              { id: 2, name: "CPA" },
              { id: 3, name: "Financial Advisor" },
            ]}
            displayKey="name"
          />
        </InputGroup> */}

          {/* {fields &&
          fields.map((data, index) => {
            const { value, Component, title, name, onChange, style } = data;
            return (
              <InputGroup>
                <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                  {title || value.title}
                </Text>

                <Component
                  key={index}
                  value={value}
                  name={name}
                  onChange={onChange}
                  style={style}
                />
              </InputGroup>
            );
          })} */}
        </Style.FieldsContainer>
      ) : (
        <Style.FieldsContainer style={{marginTop:"2rem"}}>
          <div style={{ width: "46%" }}>
            <label>Upload Collection File</label>
            <div className="file-upload-field-wrapper">
              <label
                htmlFor="collectionFile"
                className="upload-btn"
                style={{
                  cursor: "pointer",
                  width: "92%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "0px",
                }}
              >
                <input
                  type="file"
                  // ref={fileInputRef}
                  // style={{ display: "none" }}
                  id="collectionFile"
                  name="collectionFile"
                  accept=".csv"
                  onChange={(e) => {
                    console.log(e.target.files[0]);
                    uploadCollection(e);
                  }}
                />
                <img src={fileUploadIcon} alt="Upload" />
              </label>
            </div>
          </div>
          <div style={{ width: "46%" }}>
            <label>Download Sample File</label>
            <div className="file-upload-field-wrapper" style={{background:"#2A3DA3",}}>
              <div
                className="upload-btn"
                style={{
                  cursor: "pointer",
                  width: "92%",
                  display: "flex",
                  alignItems: "baseline",
                  justifyContent: "space-between",
                  marginBottom: "0px",
                  fontWeight:"600"
                }}
                onClick={downloadSampleFile}
              >
              Download Sample File
                <img src={downloadIcon}  style={{ width:"20px",height:"20px" }} alt="download" />
              </div>
            </div>
          </div>
        </Style.FieldsContainer>
      )}
      <NewLoader isLoading={loading} />
      {modalTitle === "View Item" ? (
        <Style.ButtonsContainer
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Style.SaveButton onClick={close}>Close</Style.SaveButton>
        </Style.ButtonsContainer>
      ) : (
        <Style.ButtonsContainer>
          <Style.CancelButton onClick={close}>Cancel</Style.CancelButton>
          <Style.SaveButton onClick={submitData}>
            Save
            {/*{modalTitle === "Add Item" ? "Add" : "Update"}*/}
          </Style.SaveButton>
        </Style.ButtonsContainer>
      )}
    </Modal>
  );
}

export default AddSimpleModal;
